<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 6.25L9.5 3L4 6.25M15 6.25V12.75L9.5 16M15 6.25L9.5 9.5M9.5 16L4 12.75V6.25M9.5 16V9.5M4 6.25L9.5 9.5"
        stroke="var(--icon-color)" stroke-width="2" />
    <path
        d="M28 19.25L22.5 16L17 19.25M28 19.25V25.75L22.5 29M28 19.25L22.5 22.5M22.5 29L17 25.75V19.25M22.5 29V22.5M17 19.25L22.5 22.5"
        stroke="var(--icon-color)" stroke-width="2" />
    <path d="M7 19V26H14" stroke="var(--icon-color)" stroke-width="2" />
    <path d="M25 14L25 7L18 7" stroke="var(--icon-color)" stroke-width="2" />
</svg>

